<template>
  <div>
    <el-dialog
      :title="
        submitMode +
        ' ' +
        formTitle +
        (sellerNameComputed !== '' ? ' a ' + sellerNameComputed : '')
      "
      :visible.sync="dialogFormVisible"
      :before-close="closeEventDialog"
    >
      <el-form :model="form" ref="form" label-position="top">
        <el-row>
          <el-col :span="13">
            <el-form-item
              label="Titulo"
              prop="title"
              :rules="[
                {
                  required: true,
                  message: 'El titulo del evento es requerido',
                  trigger: 'blur'
                }
              ]"
            >
              <el-input
                v-model="form.title"
                :disabled="eventSelectedIsTask"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col class="text-center" :span="1">&nbsp;</el-col>
          <el-col class="ml-15" :span="3">
            <el-form-item label="Todo el dia">
              <el-switch
                v-model="form.allDay"
                :disabled="eventSelectedIsTask"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col class="text-center" :span="5">
            <el-form-item label="Tipo">
              <el-select
                v-model="form.agendaType"
                placeholder="Evento"
                :disabled="eventSelectedIsTask"
              >
                <el-option
                  v-for="item in agendaTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- Disabled because right now colors will represent a status and therefore shouldn't be edited-->
          <!-- <el-col :span="5">
            <el-form-item label="Color">
            <el-color-picker
              v-model="form.color"
              :predefine="predefineColors"
              :disabled="eventSelectedIsTask"
            ></el-color-picker>
          </el-form-item>
          </el-col> -->
        </el-row>
        <!-- <el-form-item label="Contacto">
          <el-input
            type="textarea"
            v-model="contact"
            :disabled="true"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="Descripción">
          <el-input
            type="textarea"
            v-model="form.description"
            :disabled="eventSelectedIsTask"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="Fecha de Inicio"
          prop="startDate"
          :rules="[
            {
              required: true,
              message: 'Inserta una fecha válida',
              trigger: 'blur'
            }
          ]"
        >
          <el-col :span="11">
            <el-date-picker
              type="date"
              placeholder="Fecha"
              v-model="form.startDate"
              style="width: 100%"
              :disabled="eventSelectedIsTask"
            ></el-date-picker>
          </el-col>
          <el-col v-if="!form.allDay" class="text-center" :span="2">-</el-col>
          <el-col v-if="!form.allDay" :span="11">
            <el-time-picker
              type="fixed-time"
              placeholder="Hora"
              v-model="form.startTime"
              style="width: 100%"
              format="HH:mm"
              :disabled="eventSelectedIsTask"
            ></el-time-picker>
          </el-col>
        </el-form-item>
        <el-form-item
          label="Fecha de Fin"
          prop="endDate"
          :rules="[
            {
              required: true,
              message: 'Inserta una fecha válida',
              trigger: 'blur'
            }
          ]"
        >
          <el-col :span="11">
            <el-date-picker
              type="date"
              placeholder="Fecha"
              v-model="form.endDate"
              style="width: 100%"
              :disabled="eventSelectedIsTask && !userIsSupervisor"
            ></el-date-picker>
          </el-col>
          <el-col v-if="!form.allDay" class="text-center" :span="2">-</el-col>
          <el-col v-if="!form.allDay" :span="11">
            <el-time-picker
              type="fixed-time"
              placeholder="Hora"
              v-model="form.endTime"
              style="width: 100%"
              format="HH:mm"
              :disabled="eventSelectedIsTask && !userIsSupervisor"
            ></el-time-picker>
          </el-col>
        </el-form-item>
        <el-switch
          v-model="value1"
          active-color="#337CCF"
          inactive-color="#1450A3"
          active-text="Clientes"
          inactive-text="Prospectos"
          v-if="IsInRoles([roles.SoporteVentas, roles.EjecutivoDeVentas])"
        >
        </el-switch>

        <el-form-item
          v-if="
            value1 == true &&
            IsInRoles([roles.SoporteVentas, roles.EjecutivoDeVentas])
          "
          style="position: relative; top: 19px"
        >
          <!-- <h4>{{ this.clientvalue }}</h4> -->
          <!-- <h4>{{ this.value1 }}</h4> -->

          <el-select
            v-model="clientvalue"
            clearable
            filterable
            placeholder="Clientes"
          >
            <el-option
              v-for="item in customerCitas"
              :key="item.CustomerCode"
              :label="item.CustomerName"
              :value="item.CustomerCode"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          v-else-if="
            value1 == false &&
            IsInRoles([roles.SoporteVentas, roles.EjecutivoDeVentas])
          "
          style="position: relative; top: 19px"
        >
          <!-- <h4>{{ this.prospectValue }}</h4> -->

          <el-select
            v-model="prospectValue"
            clearable
            filterable
            placeholder="Prospectos"
          >
            <el-option
              v-for="item2 in prospectCitas"
              :key="item2.ContactCode"
              :label="item2.Name"
              :value="item2.ContactCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeEventDialog">Cancelar</el-button>

        <!--v-if="rulesForDisablingDelete ? !rulesForDisablingDelete : false"-->
        <el-button type="danger" @click="openDeleteDialog" v-loading="loading"
          >Eliminar</el-button
        >
        <el-button
          type="primary"
          @click="submitEvent"
          v-loading="loading"
          v-if="
            rulesForDisablingSaveButton ? !rulesForDisablingSaveButton : true
          "
          >Guardar</el-button
        >
      </span>
    </el-dialog>
    <!-- Event Delete Dialog -->
    <el-dialog
      title="Confirmación de eliminación"
      :visible.sync="deleteConfirmationVisible"
      width="30%"
    >
      <span>¿Está seguro/a de que desea eliminar este evento?</span>
      <br />
      <span>Esta acción no puede ser revertida</span>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="deleteConfirmationVisible = false"
          v-loading="loading"
          >Cancelar</el-button
        >
        <el-button type="danger" @click="handleDeleteEvent" v-loading="loading"
          >Eliminar</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment-timezone";
//import calendarclient from "./calendarclient";
export default {
  name: "CalendarEventForm",
  props: {
    form: {
      type: Object,
      default: function () {
        return {
          title: "",
          description: "",
          allDay: false,
          startDate: "",
          startTime: "",
          endDate: "",
          endTime: "",
          agendaType: 0,
          color: "#F22727",
          DealsId: ""
        };
      }
    },
    submitMode: {
      type: String
    },
    dialogFormVisible: {
      type: Boolean
    },
    rulesForDisablingSaveButton: {
      type: Boolean,
      default: false
    },
    rulesForDisablingDelete: {
      type: Boolean,
      default: false
    },
    eventSelectedIsTask: {
      type: Boolean,
      default: false
    },
    userIsSupervisor: {
      type: Boolean,
      default: false
    },
    currentlyChosenAgenda: {
      type: Object,
      default: function () {
        return {};
      }
    },
    userId: {
      type: Number,
      default: function () {
        return this.$store.state.user.user.UserID;
      }
    },
    currentChosenCalendarID: {
      type: Number
    },
    prospect: {
      type: String
    },
    contact: {
      type: String
    },
    Client: {
      type: String
    },
    Descripcion: {
      type: String
    },
    Type: {
      type: Boolean,
      default: false
    },
    TipoAgenda: {
      type: Number,
      default: 0
    },
    DealsId: {
      type: Number
    },
    sellerName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      agendaTypeOptions: [
        {
          value: 0,
          label: "Evento"
        },
        {
          value: 1,
          label: "Cita"
        },
        {
          value: 2,
          label: "Presentación"
        },
        {
          value: 3,
          label: "Agendar Llamada"
        }
      ],
      submitModeOptions: {
        Add: "Agregar",
        Edit: "Editar"
      },
      deleteConfirmationVisible: false,
      loading: false,
      clientvalue: "",
      value1: true,
      value: "",
      prospectValue: "",
      customerCitas: [],
      prospectCitas: []
    };
  },

  computed: {
    formTitle() {
      if (this.currentlyChosenAgenda.event) {
        if (this.currentlyChosenAgenda.event.extendedProps.isTask) {
          return "Tarea";
        } else {
          return "Evento";
        }
      } else {
        return "Evento";
      }
    },
    sellerNameComputed() {
      if (this.TipoAgenda === 3 || this.TipoAgenda === 1) {
        return this.sellerName;
      } else {
        return "";
      }
    }
  },
  created() {
    this.Getcustomercode();
    this.GetProspecode();
  },

  // mounted(){

  // },
  methods: {
    ...mapActions("calendar", [
      "create",
      "update",
      "updateTaskInApi",
      "delete"
    ]),
    submitEvent() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // this.$emit("submit-event", this.form);

          if (this.submitMode === this.submitModeOptions.Add) {
            this.setEvent();
          } else if (this.submitMode === this.submitModeOptions.Edit) {
            if (this.eventSelectedIsTask) {
              this.updateTask();
            } else if (!this.eventSelectedIsTask) {
              this.updateEvent();
            }
          }
        }
      });
    },
    setEvent() {
      this.loading = true;

      let start = moment(this.form.startDate);
      if (this.form.startTime) {
        start.add(moment(this.form.startTime).format("HH"), "hours");
        start.add(moment(this.form.startTime).format("mm"), "minutes");
      }

      let event = {
        id: new Date().getTime(),
        title: this.form.title,
        description: this.form.description,
        start: start,
        allDay: this.form.allDay,
        agendaType: this.form.agendaType,
        DealId: this.form.DealsId
      };

      if (this.form.color) event.color = this.form.color;
      if (this.form.endDate) {
        let end = moment(this.form.endDate);
        if (this.form.endTime) {
          end.add(moment(this.form.endTime).format("HH"), "hours");
          end.add(moment(this.form.endTime).format("mm"), "minutes");
        }
        // else {
        // end.add(24, "hours");
        // }

        event.end = end;
      }

      event.end = event.end.format();
      event.start = event.start.format();

      this.create({
        CalendarioID: this.currentChosenCalendarID,
        CreatedBy: this.$store.state.user.user.UserID,
        Content: event.description,
        DateTime: event.start,
        StarDate: event.start,
        EndDate: event.end,
        Title: event.title,
        Description: event.description,
        AllDay: event.allDay,
        Color: event.color,
        AgendaType: event.agendaType,
        clientCode: this.clientvalue,
        ProspectCode: this.prospectValue,
        DealId: event.DealId
      })
        .then(() => {
          this.loading = false;
          this.closeEventDialog();
          this.$message.success("Evento creado exitosamente");
        })
        .catch(() => {
          this.loading = false;
          this.closeEventDialog();
          this.$message.error("Error al crear evento");
        });
    },
    updateEvent() {
      this.loading = true;

      let event = {
        id: new Date().getTime(),
        title: this.form.title,
        description: this.form.description,
        allDay: this.form.allDay,
        start: {},
        end: {},
        agendaType: this.form.agendaType
      };

      if (this.form.color) event.color = this.form.color;

      let currentEndDate = new Date(
        this.currentlyChosenAgenda.event.extendedProps.endDate
      );
      let newEndDate = new Date(this.form.endDate);
      let newEndTime = new Date(this.form.endTime);

      let currentStartDate = new Date(
        this.currentlyChosenAgenda.event.extendedProps.startDate
      );
      let newStartDate = new Date(this.form.startDate);
      let newStartTime = new Date(this.form.startTime);

      // Change start hours and minutes

      if (
        currentStartDate.getHours() != newStartTime.getHours() ||
        currentStartDate.getMinutes() != newStartTime.getMinutes()
      ) {
        newStartDate.setHours(newStartTime.getHours());
        newStartDate.setMinutes(newStartTime.getMinutes());
      }

      let start = moment(newStartDate);
      event.start = start;

      // Change end hours and minutes
      if (
        currentEndDate.getHours() != newEndTime.getHours() ||
        currentEndDate.getMinutes() != newEndTime.getMinutes()
      ) {
        newEndDate.setHours(newEndTime.getHours());
        newEndDate.setMinutes(newEndTime.getMinutes());
      }

      let end = moment(newEndDate);
      event.end = end;

      event.end = event.end.format();
      event.start = event.start.format();

      this.update({
        CalendarioID: this.currentChosenCalendarID,
        CreatedBy: this.currentlyChosenAgenda.event.extendedProps.createdBy,
        Content: event.description,
        DateTime: event.start,
        StarDate: event.start,
        EndDate: event.end,
        Title: event.title,
        Description: event.description,
        AllDay: event.allDay,
        Color: event.color,
        Id: this.currentlyChosenAgenda.event.id,
        AgendaType: event.agendaType
      })
        .then(() => {
          this.loading = false;
          this.closeEventDialog();
          this.$message.success("Evento modificado exitosamente");
        })
        .catch(() => {
          this.loading = false;
          this.closeEventDialog();
          this.$message.error("Error al modificar evento");
        });
    },
    updateTask() {
      this.loading = true;

      let event = {
        id: new Date().getTime(),
        title: this.form.title,
        description: this.form.description,
        allDay: this.form.allDay,
        start: {},
        end: {}
      };

      if (this.form.color) event.color = this.form.color;

      let currentEndDate = new Date(
        this.currentlyChosenAgenda.event.extendedProps.endDate
      );
      let newEndDate = new Date(this.form.endDate);
      let newEndTime = new Date(this.form.endTime);

      let currentStartDate = new Date(
        this.currentlyChosenAgenda.event.extendedProps.startDate
      );
      let newStartDate = new Date(this.form.startDate);
      let newStartTime = new Date(this.form.startTime);

      // Change start hours and minutes
      if (
        currentStartDate.getHours() != newStartTime.getHours() ||
        currentStartDate.getMinutes() != newStartTime.getMinutes()
      ) {
        newStartDate.setHours(newStartTime.getHours());
        newStartDate.setMinutes(newStartTime.getMinutes());
      }

      let start = moment(newStartDate);
      event.start = start;

      // Change end hours and minutes
      if (
        currentEndDate.getHours() != newEndTime.getHours() ||
        currentEndDate.getMinutes() != newEndTime.getMinutes()
      ) {
        newEndDate.setHours(newEndTime.getHours());
        newEndDate.setMinutes(newEndTime.getMinutes());
      }

      let end = moment(newEndDate);
      event.end = end;

      event.end = event.end.format();
      event.start = event.start.format();

      this.updateTaskInApi({
        ObjetiveID: this.currentlyChosenAgenda.event.extendedProps.objectiveId,
        Id: this.currentlyChosenAgenda.event.id,
        Description: event.description,
        Name: this.currentlyChosenAgenda.event.extendedProps.originalTitle,
        ResponsableId:
          this.currentlyChosenAgenda.event.extendedProps.responsableId,
        LimiteDate: event.end,
        CompanySelected: this.currentCompany,
        Percentage: this.currentlyChosenAgenda.event.extendedProps.percentage
      })
        .then(() => {
          this.loading = false;
          this.closeEventDialog();
          this.$message.success("Tarea modificada exitosamente");
        })
        .catch(() => {
          this.loading = false;
          this.closeEventDialog();
          this.$message.error("Error al modificar tarea");
        });
    },
    Getcustomercode() {
      this.loading = true;
      this.$http
        .get("/api/Calendar/getclientescitas")
        .then((resp) => {
          this.customerCitas = resp.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
          // this.clientvalue = "";
          this.prospectValue = "";
        });
    },
    GetProspecode() {
      this.loading = true;
      this.$http
        .get("/api/Calendar/getProspectcitas")
        .then((resp) => {
          this.prospectCitas = resp.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
          this.prospectValue = "";
          this.clientvalue = "";
        });
    },

    async handleDeleteEvent() {
      try {
        this.loading = true;
        await this.delete({
          AgendaID: this.currentlyChosenAgenda.event.id,
          UserId: this.userId
        });
        this.$message.success("Evento eliminado exitosamente");
      } catch {
        this.loading = false;
        this.closeEventDialog();
        this.closeDeleteDialog();
        this.$message.error("Error al eliminar evento");
      } finally {
        this.loading = false;
        this.closeEventDialog();
        this.closeDeleteDialog();
      }
    },
    closeEventDialog() {
      this.$emit("close-event-dialog");
      this.$refs["form"].resetFields();
      this.form.title = "";
      this.form.description = "";
      this.form.allDay = false;
      this.form.startDate = "";
      this.form.startTime = "";
      this.form.endDate = "";
      this.form.endTime = "";
      this.form.agendaType = 0;
      this.form.color = "#F56C6C";
    },
    openDeleteDialog() {
      this.deleteConfirmationVisible = true;
    },
    closeDeleteDialog() {
      this.deleteConfirmationVisible = false;
    }
  },
  watch: {
    prospect(newProspect) {
      this.form.DealsId = this.DealsId;
      if (newProspect) {
        if (!this.Type) {
          this.form.title = `Cita - ${newProspect}`;
          this.form.agendaType = 1; // Cita
          this.form.description = this.Descripcion;
          var filter = this.prospectCitas.find(
            (element) => element.Name == newProspect
          );
          this.prospectValue = filter.Name;
        }
      }
    },

    Client(newClient) {
      if (newClient) {
        if (this.Type) {
          if (this.TipoAgenda == 1) {
            this.form.title = `Cita - ${newClient}`;
            this.form.agendaType = 1; // Cita
          } else if (this.TipoAgenda == 3) {
            this.form.title = `Agendar Llamada a - ${newClient}`;
            this.form.agendaType = 3; // Cita
          }
          this.clientvalue = "";
          this.form.description = this.Descripcion;
          var filter = this.customerCitas.find(
            (element) => element.CustomerName == newClient
          );
          this.clientvalue = filter.CustomerCode;
        }
      }
    }
  }
};
</script>
